import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.25em] font-semibold text-[#CBA135] ${className}`}>
    {children}
  </p>
);

export const ArrowButton = ({ to, children, dark = false, testId }) => (
  <a
    href={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-3 rounded-full px-8 py-4 text-sm font-semibold tracking-wide transition-colors duration-300 ${
      dark
        ? "bg-[#FAF8F5] text-[#2A1D1A] hover:bg-[#CBA135] hover:text-[#2A1D1A]"
        : "bg-[#C05A45] text-[#FAF8F5] hover:bg-[#2A1D1A]"
    }`}
  >
    {children}
    <span className="inline-block transition-transform duration-300 group-hover:translate-x-1.5">→</span>
  </a>
);
